import React from 'react';
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import ListingComponent from '../../components/ListingComponent.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams, useNavigate } from "react-router-dom";
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: true };
  const params = useParams();
  const navigate = useNavigate();
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'nomenclature_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Mobile Number',
      attr: 'mobile_number',
    },
    {
      ...defaultHeaderConfig,
      label: 'Employee Id',
      attr: 'employee_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
    },
    {
      ...defaultHeaderConfig,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_technician.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id)}>
              <FontAwesomeIcon icon={faEdit} />
            </div>
          </UiAction>
        </div>
      }
    },
  ]

  const onEditClick = (id) => {
    navigate(`/service_centers/${params.id}/technician/${id}/edit`);
  }

  const onNewClick = () => {
    navigate(`/service_centers/${params.id}/technician/new`);
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_technician.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Technician</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  return <ListingComponent
    key={"Listing of technicians"}
    contentHeading="Technicians List - Results"
    listingMutation={getApi('technicians')}
    className="technicians"
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    headers={headers}
    recordsKey="technicians"
    params= {props.defaultParams}
    searchBy={['Techcian Id','Mobile Number']}
  />
};

export default Listing;

